import type { ReactNode } from "react";
import { RouterProvider } from "react-router/dom";
import type { createBrowserRouter } from "react-router";
import { AuthProvider } from "./app/auth";
import { LicenseProvider } from "./app/license-context";
import { ServicesProvider, type Services } from "./app/services";
import { FormatProvider, I18nProvider, type ClubFormatSettings } from "./i18n/I18nProvider";
import type { Locale } from "./i18n/runtime";
import { ThemeProvider } from "./theme/ThemeProvider";
import { AnnouncerProvider } from "./ui/Announcer";

type Router = ReturnType<typeof createBrowserRouter>;

export function Providers({ services, children, locale, format }: { services: Services; children: ReactNode; locale?: Locale; format?: ClubFormatSettings }) {
  return (
    <ServicesProvider services={services}>
      <ThemeProvider>
        <I18nProvider initialLocale={locale}>
          <FormatProvider club={format ?? null}>
            <AnnouncerProvider>
              <LicenseProvider>
                <AuthProvider>{children}</AuthProvider>
              </LicenseProvider>
            </AnnouncerProvider>
          </FormatProvider>
        </I18nProvider>
      </ThemeProvider>
    </ServicesProvider>
  );
}

export function App({ services, router, locale }: { services: Services; router: Router; locale?: Locale }) {
  return (
    <Providers services={services} locale={locale}>
      <RouterProvider router={router} />
    </Providers>
  );
}
